import React from 'react'

import { connect } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import EditUserForm from '../components/form/EditUserForm'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    width: '98%',
    height: '100%',
    padding: '1rem 0',
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    fontFamily: 'Montserrat, Source Sans Pro'
  },
  content_wrapper: {
    gridColumn: 'span 1',
    padding: '40px 32px'
  },
  empty_column: {
    gridColumn: 'span 1'
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 16,
    height: '15%',
    justifyContent: 'flex-start',
    marginBottom: 56,
    '& h1': {
      color: '#386093',
      fontWeight: 700,
      fontSize: 32,
      margin: 0
    },
    '& p': {
      fontWeight: 400,
      fontSize: 16,
      margin: 0
    }
  }
}))

const CreateCoordinatorPage = ({ match, componentAttribute, doormen }) => {
  const classes = useStyles()
  const { id } = match.params

  return (
    <div className={classes.root}>
      <div className={classes.content_wrapper}>
        <div className={classes.header}>
          <h1>Cadastro de novos controladores</h1>
          <p>
            Registre novos controladores facilmente e enriqueça a experiência
            educacional na sua escola
          </p>
        </div>
        <EditUserForm
          redirectPath={'/settings/doorman'}
          createdSuccess={!!doormen.currentItem && !!doormen.isFinished}
          isEdit={componentAttribute?.is_edit}
          registeredUserId={id}
          defaultOccupation={componentAttribute?.default_occupation}
        />
      </div>
      <div className={classes.empty_column} />
    </div>
  )
}

const mapStateToProps = ({ doormen }) => {
  return {
    doormen: doormen
  }
}

export default connect(mapStateToProps, null)(CreateCoordinatorPage)
